import { dispatchCommand } from '@/services/messaging/dispatchCommand';

export function updateTreatmentAreas(treatmentAreas) {
    return dispatchCommand("RequestChangeOfUserTreatmentArea", treatmentAreas);
}